import { createContext } from "react";

import { GrsSearchQuery } from "../types/search-display";

type GrsSearchQueryContextType = {
  grsSearchQueryState: GrsSearchQuery;
  setGrsSearchQueryState: React.Dispatch<React.SetStateAction<GrsSearchQuery>>;
};

export const GrsSearchQueryContext = createContext<GrsSearchQueryContextType>(
  {} as GrsSearchQueryContextType,
);
